import React, { useEffect, useState, useRef } from 'react';
import LoadingPage from 'components/LoadingPage';

const IdentificationPage = () => {
  const formRef = useRef(null);
  const [encodeData, setEncodeData] = useState('');

  useEffect(() => {
    const checkEncodeData = (retry = 0) => {
      if (window._encodeData) {
        setEncodeData(window._encodeData);
      } else if (retry < 10) {
        setTimeout(() => checkEncodeData(retry + 1), 10);
      } else {
        alert('인증 정보를 찾을 수 없습니다. 다시 시도해주세요.');
        window.close();
      }
    };

    checkEncodeData();
  }, []);

  useEffect(() => {
    if (formRef?.current && encodeData) {
      formRef.current.submit();
    }
  }, [encodeData, formRef]);

  return (
    <>
      <LoadingPage />
      <form
        method="post"
        action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb"
        target="_self"
        ref={formRef}
      >
        <input type="hidden" name="m" value="checkplusService" />
        <input type="hidden" name="EncodeData" value={encodeData} />
        <input type="hidden" name="recvMethodType" value="get" />
      </form>
    </>
  );
};

export default IdentificationPage;
